var React = require('react');

function CornerUpRight (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","fillRule":"evenodd"},React.createElement("g",{"stroke":"currentColor","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"2.5"},[React.createElement("path",{"d":"M13 12l5-5-5-5","key":0}),React.createElement("path",{"d":"M2 18v-7a4 4 0 0 1 4-4h12","key":1})])));
}

CornerUpRight.defaultProps = {"width":"20","height":"20","viewBox":"0 0 20 20"};

module.exports = CornerUpRight;

CornerUpRight.default = CornerUpRight;
